import styled from 'styled-components';
import { theme, width } from '../styles/theme';

const Button = styled.button`
  font-family: 'Gramatika', sans-serif;
  // min-height (not height) + flex centering: labels that wrap to two lines
  // on narrow phones ("Save and continue" at 14pt) grow the pill instead of
  // spilling out of a fixed 60px box. Single-line labels render identically.
  min-height: 60px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-left: 3.2em;
  padding-right: 3.2em;
  border-radius: 2em;
  font-size: 14pt;
  font-weight: 200;
  transition-property: opacity, transform;
  transition-duration: 0.1s, 0.15s;
  transition-timing-function: linear, ease;
  &:active:not(:disabled) {
    transform: scale(0.96);
  }
  margin: 0 auto;
  z-index: 9;
  cursor: pointer;
  background-color: ${theme.palette.secondary};
  border-color: ${theme.palette.primary};
  border-width: 0;
  color: ${theme.palette.white};
  &:disabled {
    background-color: ${theme.palette.disabled};
    color: ${theme.palette.white};
  }
  width: 90%;
  max-width: 320px;

  // Narrow phones: 3.2em side padding leaves too little room for the label
  // inside the 320px pill and forces a wrap — give the text that room back.
  @media (max-width: ${width.phone}px) {
    padding-left: 1.6em;
    padding-right: 1.6em;
  }

  @media (min-width: ${width.tablet}px) {
    width: auto;
  }
`;

export default Button;
